import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from 'classnames';
import PropTypes from 'prop-types';

const SpeechControl = ({ onclick, icon, colour }) => {
    const [hovered, setHovered] = useState(false);
    const btnClass = classNames('speech-btn', { 'text-secondary': !hovered, [`text-${colour}`]: hovered });
    return (
        <Button
            variant='sm'
            onClick={onclick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            className={btnClass}>
            <FontAwesomeIcon size='sm' icon={icon} />
        </Button>
    );
};

SpeechControl.propTypes = {
    onclick: PropTypes.func,
    icon: PropTypes.object,
    colour: PropTypes.string
};

export default SpeechControl;